/** 手机号正则 */
export const isMob = /^1[3,4,5,6,7,8,9]\d{9}$/;

/**
 *判断手机号格式
 */
export const isPhone = (rule: any, value: string, callback: (arg0?: Error | undefined) => void) => {
  if (value) {
    if (isMob.test(value)) {
      callback();
    } else {
      return callback(new Error("请输入合法的手机号"));
    }
  } else {
    return callback();
  }
};
